import { render, staticRenderFns } from "./ForbiddenPage.vue?vue&type=template&id=42c0fc64&scoped=true"
import script from "./ForbiddenPage.vue?vue&type=script&lang=js"
export * from "./ForbiddenPage.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenPage.vue?vue&type=style&index=0&id=42c0fc64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c0fc64",
  null
  
)

export default component.exports